export default __webpack_public_path__ + "static/media/CavaDonCarlosLogo_black.f27a030c.png";